module.exports = __webpack_public_path__ + "fonts/iconfont.4dbcbaa8.woff";